import { atom } from 'recoil';
import {
    Authentification,
    Formulaire,
    Inscription,
    ModificationMotDePasse,
    Reservation,
    UtilisateurConnecte,
} from '../../common/src/entities';
import { EtatModalAvis } from './Components/Dashboard/Utils/ModalAvisAbonnement';

export const etatFormulaire = atom<Formulaire>({
    key: 'etatFormulaire',
    default: {
        nomEcole: '',
        idCss: null,
        nomContact: '',
        prenomContact: '',
        courrielContact: '',
        telContact: '',
        nbParticipants: '',
        groupeAge: '',
        reservations: [new Reservation(), new Reservation(), new Reservation()],
        posteContact: '',
        contexte: '',
        notes: '',
    },
});

export const etatMasquerCovid19 = atom({
    key: 'etatMasquerCovid19',
    default: {
        estMasquer: true,
    },
});

export const etatInscription = atom<Inscription>({
    key: 'etatInscription',
    default: {
        nomEcole: '',
        idCss: null,
        nomContact: '',
        prenomContact: '',
        courrielContact: '',
        telContact: '',
    },
});

export const etatAuthentification = atom<Authentification>({
    key: 'etatAuthentification',
    default: {
        courriel: '',
        motDePasse: '',
    },
});

export const etatRecuperationMotDePasse = atom<Authentification>({
    key: 'etatRecuperationMotDePasse',
    default: {
        courriel: '',
    },
});

export const etatModificationMotDePasseTemp = atom<ModificationMotDePasse>({
    key: 'etatModificationMotDePasseTemp',
    default: {
        nouveauMotDePasse: '',
        confrimationNouveauMotDePasse: '',
    },
});

export const etatUtilisateurConnecte = atom<UtilisateurConnecte>({
    key: 'etatUtilisateurConnecte',
    default: {
        id: 0,
        connecte: undefined,
        admin: false,
        nom: '',
        prenom: '',
        mettreAJourMotDePasse: false,
    },
});

export const etatModalAvisAbonnement = atom<EtatModalAvis>({
    key: 'etatModalAvisAbonnement',
    default: {
        contactId: '',
        clientsAssocies: [],
        afficher: false,
    },
});
export interface PremiereVisite {
    abonnementEnCours: boolean;
    premiereVisiteTermine: boolean;
}

export const currentModalPageState = atom({
    key: 'currentModalPage',
    default: 0,
});

export const etatPremiereVisite = atom<PremiereVisite>({
    key: 'etatPremiereVisite',
    default: {
        abonnementEnCours: false,
        premiereVisiteTermine: false,
    },
});
